import store from "@/store/store";
import {httpResource} from "@/resources/http.resource";
import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";

export namespace ICamsPhoto {
  export enum Action {
    CamsPhoto = 'camsPhoto',
  }

  export interface IPayloadMoves {
    movId: number;
    carNumber: string;
  }

  export interface IPayloadCams {
    camId: number;
    carNumber?: string;
    dateEvent?: string;
    intervalMinutes?: number;
    lastPhotoFlag?: boolean;
  }

  export interface IServerCamsPhoto {
    id: number;
    src: string;
    camName?: string;
    cameraType?: CameraType;
  }

  export enum CameraType {
    enter = 'enter',
    exit = 'exit',
    check = 'check',
  }

  export async function GetCamsPhoto(payload: IPayloadMoves | IPayloadCams) {
    const asyncAction = async () => {
      const action = Action.CamsPhoto;
      const params: any = {...payload};

      const {data: {result: response }} = await httpResource.httpAction({ action, params });
      let result = response && response.camsPhoto ? prepareCamsPhoto(response.camsPhoto) : [];
      return result;
    };

    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  export function prepareCamsPhoto(camsPhoto: IServerCamsPhoto[]): IAppMediaPopup.IMediaFile[] {
    let result: IAppMediaPopup.IMediaFile[] = [];
    let fileProps: any[] = [
      { prop: 'camName', label: 'Камера:', },
    ];

    camsPhoto.forEach((item: IServerCamsPhoto) => {
      let photoInfo: IAppMediaPopup.IMediaFileInfo[] = [];
      fileProps.forEach(propItem => {
        let infoData: IAppMediaPopup.IMediaFileInfo = { ...propItem, value: item[propItem.prop] };
        if (propItem.checkIcon) propItem.checkIcon(item, infoData);
        if (propItem.checkClass) propItem.checkClass(item, infoData);
        photoInfo.push(infoData);
      });

      let resultItem: IAppMediaPopup.IMediaFile = {
        ...item,
        photoInfo: photoInfo,
        type: IAppMediaPopup.MediaType.Image,
      };

      result.push(resultItem);
    });

    return result;
  }
}